import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import type { TrayPredictionRequestDto } from '@peritasai/types';
import type { TrayPredictionEntity } from './tray-prediction.entity';
import { oemTrayRepository } from './repository';

export const oemTrayKeys = {
  all: ['oem-tray'] as const,
  predict: () => [...oemTrayKeys.all, 'predict'] as const,
} as const;

/** Variables for {@link useOemTrayPrediction}. */
export interface OemTrayPredictionVariables {
  request: TrayPredictionRequestDto;
  signal?: AbortSignal;
}

/**
 * Run OEM tray inference. Prediction is a command over a captured frame (not
 * cacheable server state), so it is modeled as a mutation.
 */
export function useOemTrayPrediction(): UseMutationResult<
  TrayPredictionEntity,
  Error,
  OemTrayPredictionVariables
> {
  return useMutation({
    mutationKey: oemTrayKeys.predict(),
    mutationFn: ({ request, signal }: OemTrayPredictionVariables) =>
      oemTrayRepository.predict(request, signal),
  });
}
